export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('table.action.modify'),
        permission: 'ai_gateways_update',
        action: obj => {
          this.createDialog('AiGatewayCreateDialog', {
            type: 'update',
            data: [obj],
            onManager: this.onManager,
          })
        },
        meta: () => ({
          validate: true,
        }),
      },
      {
        label: this.$t('cloudenv.text_108'),
        permission: 'ai_gateways_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('cloudenv.text_108'),
            name: this.$t('ai.ai_gateway'),
            onManager: this.onManager,
          })
        },
      },
    ]
  },
}
